<template>
  <!-- 底部 -->
  <div style="margin: 0 auto; width:100%;background-color: #f5f2f2;padding: 20px 0;box-sizing: border-box ">
    <!--了解我们-->
    <!-- 上部 -->
    <div class="footTop">
      期待您的入驻，共建、共赢洪湖莲藕供应链平台
    </div>

    <!-- <div>
      <div style="margin:0 auto; border:1px solid rgb(230,230,230);width:1350px;"></div>
    </div> -->

    <!-- 中部 -->
    <div class="footCenter">
      <div>
        <p class="max_p">购物指南</p>
        <p class="min_p">购物流程</p>
        <p class="min_p">常见问题</p>
        <p class="min_p">联系客服</p>
      </div>
      <div>
        <p class="max_p">配送方式</p>
        <p class="min_p">上门自提</p>
        <p class="min_p">配送服务查询</p>
        <p class="min_p">配送费收取标准</p>
      </div>
      <div>
        <p class="max_p">支付方式</p>
        <p class="min_p">货到付款</p>
        <p class="min_p">在线支付</p>
        <p class="min_p">分期付款</p>
        <p class="min_p">公司转账</p>
      </div>
      <div>
        <p class="max_p">售后服务</p>
        <p class="min_p">售后政策</p>
        <p class="min_p">价格保护</p>
        <p class="min_p">退款说明</p>
        <p class="min_p">返修/退换货</p>
      </div>
      <div>
        <p class="max_p">了解我们</p>
        <p class="min_p">关于我们</p>
        <p class="min_p">企业责任</p>
        <p class="min_p">新闻中心</p>
        <p class="min_p">关于我们</p>
      </div>

      <div class="erweima">
        <div style="text-align: center;">
          <img src="./image/erweima1.png" alt style="width:70px; height:70px;" />
          <p style="font-size: 1vw">APP</p>
        </div>
        <div style="text-align: center;">
          <img src="./image/erweima2.png" alt style="width:70px; height:70px" />
          <p style="font-size: 1vw">公众号</p>
        </div>
      </div>
    </div>
    <!-- 
    <div>
      <div style="margin:0 auto; border:1px solid rgb(230,230,230);width:1350px;"></div>
    </div> -->

    <!-- 下部 -->
    <div class="footFoot">
      <div class="forMe" v-for="forMe of for_me_th" :key="forMe.id">
        <p @click="to(forMe.id)">{{ forMe.title }}</p>
      </div>

    </div>
    <p class="pBox">版权所有洪湖莲藕供应链(湖北)有限公司</p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      for_me_th: [
        { id: 0, title: "关于我们" },
        { id: 1, title: "联系我们" },
        { id: 2, title: "合作招商" },
        { id: 3, title: "商家帮助" },
        { id: 4, title: "营销中心" },
        { id: 5, title: "手机APP" },
        { id: 6, title: "友情链接" },
        { id: 7, title: "销售联盟" },
        { id: 8, title: "洪湖莲藕社区" },
        { id: 9, title: "隐私政策" },
        { id: 10, title: "法律声明" },
        { id: 11, title: "知识产权" },
        { id: 12, title: "后台管理" },
      ]
    };
  },

  methods: {
    to(a){
      if(a === 12){
        // 跳转后台
        window.location.href = "http://honghulianou.net/memeber";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.footTop {
  font-size: 2.5vw;
  color: green;
  font-weight: bold;
  text-align: center;
  margin-bottom: 40px;
}

.footCenter {
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  .min_p {
    color: rgb(107, 107, 107);
    font-size: 0.6vw;

    &:hover {
      color: #409eff;
      cursor: pointer;
    }
  }

  .max_p {
    font-size: 0.8vw;
  }

  .erweima {
    display: flex;
  }
}

.footFoot {
  margin: 0 auto;
  text-align: center;
  color: rgb(107, 107, 107);
  font-size: 0.6vw;
  display: flex;
  justify-content: space-around;
  width: 60%;
}

.pBox {
  color: rgb(107, 107, 107);
  font-size: 0.6vw;
  text-align: center;
}






























@media (max-width: 599px) {
  .footTop {
    font-size: 15px;
    color: green;
    font-weight: bold;
    text-align: center;
    margin-bottom: 10px;
  }

  .footCenter {
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
    
    .min_p {
      color: rgb(107, 107, 107);
      font-size: 9px;

      &:hover {
        color: #409eff;
        cursor: pointer;
      }
    }

    .max_p {
      font-size: 10px;
    }

    .erweima {
      display: flex;
      width: 100%;
      justify-content: center;
    }
  }

  .footFoot {
    margin: 0 auto;
    text-align: center;
    color: rgb(107, 107, 107);
    font-size: 8px;
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }
  .forMe{
    margin-left: 2px;
  }

  .pBox {
    color: rgb(107, 107, 107);
    font-size: 8px;
    text-align: center;
  }


}
</style>